import React, { useEffect, useMemo, useState } from "react";
import callIcon from "../../assets/ic-doc/ic-vezo-call.png";
import CopyToClipboard from "react-copy-to-clipboard";
import MainPageDialog from "../../components/dialog";
import LoadingBars from "../../components/loadingBar";
import moment from "moment";
import { cloneDeep, forEach } from "lodash";
import { useForm, useWatch } from "react-hook-form";
import { ReactSelectField } from "../../components/reactHookFormFields/selectField";
import { toast } from "react-toastify";
import useSound from 'use-sound';
import vezoSound from '../../assets/audio/new_member.mp3';
import { TabbedPanelE10x } from "../../components/tabbedPanel/tabbed_panel";
import { useGetVezoRoomsQuery, useGetVezoSessionsListingQuery, useGetVezoSessionsWaitingListQuery,
    useGetVezoDisclaimerQuery, 
    useGetNursingHomeCallsQuery} from "../../services/vezoService";
import { useGroupChatContext } from "../../context/groupchatContext";
import ActionDialog from "../../components/actionDialog";
import { getBaseUrl } from "../../helpers/utility";

// import Unassignedsession from "./unassigned-session";

const VezoSessions = ({closeHandler}) => {

    const [playSound] = useSound(vezoSound);
    const { control, setValue, getFieldState, handleSubmit, formState: { errors }, reset } = useForm({});
    const [vezoCurrentRoom, setVezoCurrentRoom] = useState(null);
    const [listType, setListType] = useState('current');
    const [listData, setListData] = useState(null);
    const [lastWaitingListChecked, setLastWaitingListChecked] = useState(null);
    const [disclaimer, setDisclaimer] = useState(null);
    const [tabs, setTabs] = useState([
        {
            title: "Current Sessions",
            slug: "current",
            active: true
        },
        {
            title: "Future Sessions",
            slug: "future",
            active: false
        },
        {
            title: "Previous Sessions",
            slug: "previous",
            active: false
        },
    ]);
    const [disclaimerPopupData, setDisclaimerPopupData] = useState({open: false, title: ''})

    const currentRoomWatch = useWatch({ control, name: "current_room" });

    const groupChatContext = useGroupChatContext();
    const {authData, vezoCallData, setVezoCallData, selectedChat} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        vezoCallData: groupChatContext.vezoCallData,
        setVezoCallData: groupChatContext.setVezoCallData
    }));

    const { data: vezoAllRooms } = useGetVezoRoomsQuery(null, { skip: !authData?.is_provider });
    const { data: vezoSessionsListing, isLoading: isListingloading, refetch: refetchVezoSessionsListing } = useGetVezoSessionsListingQuery({
        limit: 1000,
        pid: selectedChat?.pid,
        date_from: (moment().subtract(7,'d').format('YYYY-MM-DD')+' '+'00:00:00'),
        date_to: (moment().add(7,'d').format('YYYY-MM-DD')+' '+'23:59:59'),
        status: 'scheduled,in-progress,on-hold,completed',
        vezo_id: vezoCurrentRoom?.vezo_id,
    }, { skip: !vezoCurrentRoom?.vezo_id || !authData?.is_provider, refetchOnMountOrArgChange: true });

    const { data: vezoSessionsWaitingList, isLoading: isWaitingListloading, refetch: refetchVezoSessionsWaitingList } = useGetVezoSessionsWaitingListQuery({
        vezo_id: vezoCurrentRoom?.vezo_id,
    }, { skip: !vezoCurrentRoom?.vezo_id || !authData?.is_provider });

    const {data: nurseVezoSessionsListing} = useGetNursingHomeCallsQuery({pid: selectedChat?.pid}, {skip: authData?.is_provider})
    console.log("nurseVezoSessionsListing: ", nurseVezoSessionsListing)
    const { data: vezoDisclaimer } = useGetVezoDisclaimerQuery(null, {skip: !authData?.is_provider});

    useEffect(() => {
        if (vezoDisclaimer && vezoDisclaimer?.length > 0 && vezoDisclaimer[0]?.TermsCondition && vezoDisclaimer[0]?.TermsCondition.text) {
            setDisclaimer(vezoDisclaimer[0]?.TermsCondition.text);
        }
    }, [vezoDisclaimer]);

    let vezoSessionsWaitingTimestamp = 0;
    useEffect(() => {
        if (vezoSessionsWaitingList) {
            vezoSessionsWaitingTimestamp = new Date().getTime();
        }
    }, [vezoSessionsWaitingList]);

    useEffect(() => {
        if (vezoSessionsListing){
            let results = {
                previous: [],
                current: [],
                future: [],
            };
            forEach(vezoSessionsListing, (session) => {
                let todayDate = new Date(moment().format('YYYY-MM-DD')).getTime();
                let tempDate = new Date(session.datetime.split(' ')[0]).getTime();
                if (tempDate < todayDate) {
                    results.previous.push(session);
                } else if (tempDate == todayDate) {
                    results.current.push(session);
                } else if (tempDate > todayDate) {
                    results.future.push(session);
                }
            });
            setListData(results);
        }
    }, [vezoSessionsListing]);

    useEffect(() => {
        if(currentRoomWatch && currentRoomWatch?.vezo_id && vezoCurrentRoom?.vezo_id != currentRoomWatch?.vezo_id){
            setVezoCurrentRoom(currentRoomWatch);
            setTimeout(() => {
                refetchVezoSessionsListing && refetchVezoSessionsListing();
                refetchVezoSessionsWaitingList && refetchVezoSessionsWaitingList();
            }, 500);
        }
    }, [currentRoomWatch]);

    const startVezoSession = (item) => {
        const disclaimerData = {
            open: true,
            title: disclaimer,
            callBackFun: () => {
                const params = {
                    show: true,
                    url: `${getBaseUrl().telemed_url}?mid=${item?.visit_key}&token=${authData.auth}&parent=provider_app&tz=${new Date().getTimezoneOffset()}&practice_id=${authData.practice?.id}&consent_signed=1`,
                    last_call: cloneDeep(item)
                }
                setVezoCallData(params);
            }
        };
        setDisclaimerPopupData(disclaimerData)
    };

    useEffect(() => {
        if(vezoAllRooms && vezoAllRooms.length > 0){
            let roomIndexToUse = vezoAllRooms?.findIndex((check) => (check?.user_role=="owner"));
            if(roomIndexToUse < 0){
                setVezoCurrentRoom(vezoAllRooms[0]);
                setValue("current_room", {...vezoAllRooms[0], label: vezoAllRooms[0].room_name});
            }
            else {
                setVezoCurrentRoom(vezoAllRooms[roomIndexToUse]);
                setValue("current_room", {...vezoAllRooms[roomIndexToUse], label: vezoAllRooms[roomIndexToUse].room_name});
            }
        }
    }, [vezoAllRooms]);

    const footerList = [
        {
            type: "close",
            action: () => closeHandler(),
            title: "Close",
        },
    ];

    const getTotalSessionTime = (session) => {
        let sDate = moment(session.started_at, 'YYYY-MM-DD HH:mm:ss');
        let eDate = moment(session.ended_at, 'YYYY-MM-DD HH:mm:ss');
        return (moment.utc(moment.duration(moment(eDate).diff(moment(sDate))).asMilliseconds()).format('HH:mm:ss'));
    }

    const changeTab = (tab) => {
        setListType(tab.slug)
    }

    useEffect(() => {
        if(vezoSessionsWaitingList && vezoSessionsWaitingTimestamp!=lastWaitingListChecked){
            setLastWaitingListChecked(vezoSessionsWaitingTimestamp);
            let isChanged = false;
            let tempTabs = cloneDeep(tabs);
            let tempListData = cloneDeep(listData);

            if (tempListData?.previous && tempListData?.previous?.length > 0) {
                let checkGuestsLength = countMatchingApptIds(tempListData?.previous, vezoSessionsWaitingList);
                isChanged = true;
                if (checkGuestsLength > 0) {
                    playSound();
                    tempTabs[2].sub_title = "("+(checkGuestsLength)+" member)";
                    tempTabs[2].sub_title_cls = "animate-bounce text-red-700 ml-1";
                } else {
                    tempTabs[2].sub_title = false;
                    tempTabs[2].sub_title_cls = false;
                }
                tempListData.previous = tempListData?.previous.map((session1) => {
                    let checkExist = cloneDeep(vezoSessionsWaitingList?.filter((item) => (item.appt_id == session1.appt_id)));
                    if (checkExist && checkExist.length > 0) {
                        session1.waitingList = checkExist[0]?.checked_in_guests;
                    } else {
                        session1.waitingList = [];
                    }
                    return session1;
                });
            }
            if (tempListData?.current && tempListData?.current?.length > 0) {
                let checkGuestsLength = countMatchingApptIds(tempListData?.current, vezoSessionsWaitingList);
                isChanged = true;
                if (checkGuestsLength > 0) {
                    playSound();
                    tempTabs[0].sub_title = "("+(checkGuestsLength)+" member)";
                    tempTabs[0].sub_title_cls = "animate-bounce text-red-700 ml-1";
                } else {
                    tempTabs[0].sub_title = false;
                    tempTabs[0].sub_title_cls = false;
                }
                tempListData.current = tempListData?.current.map((session2) => {
                    let checkExist = cloneDeep(vezoSessionsWaitingList?.filter((item) => (item.appt_id == session2.appt_id)));
                    if (checkExist && checkExist.length > 0) {
                        session2.waitingList = checkExist[0]?.checked_in_guests;
                    } else {
                        session2.waitingList = [];
                    }
                    return session2;
                });
            }
            if (tempListData?.future && tempListData?.future?.length > 0) {
                let checkGuestsLength = countMatchingApptIds(tempListData?.future, vezoSessionsWaitingList);
                isChanged = true;
                if (checkGuestsLength > 0) {
                    playSound();
                    tempTabs[1].sub_title = "("+(checkGuestsLength)+" member)";
                    tempTabs[1].sub_title_cls = "animate-bounce text-red-700 ml-1";
                } else {
                    tempTabs[1].sub_title = false;
                    tempTabs[1].sub_title_cls = false;
                }
                tempListData.future = tempListData?.future.map((session3) => {
                    let checkExist = cloneDeep(vezoSessionsWaitingList?.filter((item) => (item.appt_id == session3.appt_id)));
                    if (checkExist && checkExist.length > 0) {
                        session3.waitingList = checkExist[0]?.checked_in_guests;
                    } else {
                        session3.waitingList = [];
                    }
                    return session3;
                });
            }
            setTimeout(() => {
                if (isChanged) {
                    setListData(tempListData);
                    setTabs(tempTabs);
                }
            }, 100);
        }
    }, [listData?.previous, listData?.current, listData?.future, vezoSessionsWaitingList, vezoSessionsWaitingTimestamp]);

    const countMatchingApptIds = (array1, array2) => {
        let count = 0;
        for (const item1 of array1) {
            for (const item2 of array2) {
                if (item1.appt_id === item2.appt_id) {
                    count = (item2?.checked_in_guests && item2?.checked_in_guests?.length > 0) ? item2?.checked_in_guests?.length : 0;
                    break; // Exit the inner loop to avoid counting multiple matches for the same item1
                }
            }
        }
        return count;
    }

    const [availableTracks, setAvailableTracks] = useState([]);
    const navigatorAccessEvents = () => {
        navigator.getUserMedia({audio:true,video:true}, function(stream) {
            setAvailableTracks(cloneDeep(stream.getTracks()))
            stream.getTracks().forEach(x=>x.stop());
        }, err=> {
            toast.error('Camera or Microphone permissions needed! Vezo requires both media permissions to proceed the calls.');
        });
        // const windowNavigator = (window.navigator || navigator);
        // if (windowNavigator && typeof windowNavigator.permissions === 'object') {
        //     windowNavigator.permissions.query({name:'camera'}).then(function(state) {
        //         state.onchange = function(event) {
        //             if (lastCameraPermission=='denied' && event.target.state == 'granted') {
        //                 toast.options.preventDuplicates = true;
        //                 toast.success('Now vezo has camera and microphone permissions. Try again.');
        //             }
        //             setLastCameraPermission(event.target.state);
        //         };
        //         setLastCameraPermission(state.state);
        //     });
        //     windowNavigator.permissions.query({name:'microphone'}).then(function(state) {
        //         state.onchange = function(event) {
        //             if (lastMicPermission=='denied' && event.target.state == 'granted') {
        //                 toast.options.preventDuplicates = true;
        //                 toast.success('Now vezo has camera and microphone permissions. Try again.');
        //             }
        //             setLastMicPermission(event.target.state);
        //         };
        //         setLastMicPermission(state.state);
        //     });
        // }
    }

    return (
        <>
            <MainPageDialog
                title={`Scheduled Sessions`}
                onCancelHandler={() => closeHandler()}
                footer={true}
                footerList={footerList}
            >
                {authData?.is_provider ?
                    <div className="flex py-1">
                        <div className="ml-auto">
                            <ReactSelectField
                                title="Selected Room"
                                name="current_room"
                                className="w-[18rem] text-start"
                                control={control}
                                optionData={vezoAllRooms?.map((v, k) => ({
                                    ...v,
                                    label: v.room_name,
                                }))}
                                menuPlacement={"bottom"}
                            />
                        </div>
                    </div>
                : null}

                <TabbedPanelE10x tabs={tabs} onTabChange={changeTab} />
                <div className="flex flex-col items-left justify-left pt-2 border-t">
                    {!isListingloading ? (
                    (listType=='previous' ? listData?.previous : listType=='current' ? listData?.current : listType=='future' ? listData?.future : [])?.length > 0 ? (<ul role="list" className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
                        {(listType=='previous' ? listData?.previous : listType=='current' ? listData?.current : listType=='future' ? listData?.future : [])?.map((session, sessionIndex) => {
                        return (<li key={session.id} className="overflow-hidden rounded-xl border border-gray-200 relative">
                            <div className="flex items-left gap-x-24 px-2 py-2.5 p-6 font-normal border border-bgGreen rounded bg-bgGreen">
                                <div className="text-lg font-medium text-white bg-bgGreen w-[14rem]" title={session.title}>{session.title}</div>
                                {<img src={callIcon} className={`w-[3rem] h-[3rem] inline absolute right-2 ${(vezoCallData?.show) ? 'opacity-25' : 'cursor-pointer'} ${(listType=='future' || session.status=='completed' || (session.user_id!=authData.id)) ? 'invisible' : ''}`} alt={(vezoCallData?.show) ? 'Another Call Inprogress' : 'Call'} title={(vezoCallData?.show) ? 'Another Call Inprogress' : 'Call'}
                                    onClick={() => {
                                    navigatorAccessEvents();
                                    !vezoCallData?.show && startVezoSession(session);
                                }}
                                />}
                            </div>
                            <dl className="-my-3 divide-y divide-gray-100 px-0 pt-4 pb-3 text-sm leading-6 relative">
                                <div className="flex py-3 px-2">
                                <dt className="text-gray-500 capitalize">{session.patient.full_name}, {session.patient.sex}, {moment(session.patient.DOB).format("MM/DD/YYYY")}</dt>
                                <dd>
                                    {session.status != 'completed' && <CopyToClipboard text={session?.visit_url} onCopy={() => toast.success('URL copied')}>
                                    <a className="inline-flex absolute top-[1.5rem] right-[5rem] capitalize items-center px-2 py-1 text-xs text-gray-500 font-medium cursor-pointer" title="Copy Meeting URL">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                                        </svg>
                                    </a>
                                    </CopyToClipboard>}
                                    <span className={`inline-flex absolute right-2 capitalize items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${(session.status=='scheduled') ? ' ring-blue-400/30 bg-blue-400/10 text-blue-400' : ' bg-yellow-400/10 ring-yellow-400/20 text-yellow-600'}`}>{session.status}</span>
                                </dd>
                                </div>
                                <div className="flex rounded-md bg-gray-400/10 px-2 py-1 text-xs text-gray-600 font-medium w-full relative h-[2.5rem]">
                                {/* <div className={'inline-flex items-center ring-1 ring-inset ring-gray-400/20 px-2'}>
                                    <strong>Provider:</strong>&nbsp;{(session.user_id=='0' && session.status!='completed') ? (
                                        <Unassignedsession
                                        key={'unassigned-session-'+session.id}
                                        session={session} />
                                    ) : (session.user_id=='0' ? 'Unassigned' : session.user_name)}
                                </div> */}
                                {session.status == 'completed' && (<div className={'px-2 py-1 text-xs font-medium absolute right-0 top-2'}>
                                        <strong>Duration:</strong> {getTotalSessionTime(session)}
                                </div>)}
                                </div>
                                {session?.waitingList && session?.waitingList?.length > 0 && <div className="flex py-1">
                                <div className={'inline-flex items-center text-red-700 ring-1 ring-inset ring-gray-400/20'}>
                                    <strong>Members:</strong>&nbsp;{session?.waitingList?.map((item, index) => (item?.user_name + (item?.in_call ? ' (In-call)' : ''))).join(', ')}
                                </div>
                                </div>}
                            </dl>
                        </li>);
                        })}
                    </ul>) : (
                    <div className="flex flex-col pt-5">
                        <div className="text-gray-500 text-md font-medium"><span className="capitalize">{listType}</span> sessions not found</div>
                    </div>
                    )) : (
                    <LoadingBars />
                    )}
                </div>
            </MainPageDialog>

            <ActionDialog
                headerTitle="Disclaimer!"
                onCancelHandler={() => setDisclaimerPopupData({ open: false })}
                onConfirmHandler={() => {
                    disclaimerPopupData.callBackFun();
                    setDisclaimerPopupData({ open: false });
                }}
                confirmButtonText="Sign"
                showModal={disclaimerPopupData.open}
                title={disclaimerPopupData?.title}
                setShowModal={() => setDisclaimerPopupData({ open: false })}
            />
        </>
    );
};

export default VezoSessions;
